import axios from 'axios';
import get from 'lodash.get';
import { from } from 'rxjs';

export const startLoadingRates = (rateModel) => {
  const request = axios.post('rate/browse', rateModel).then((response) => {
    return get(response, 'data.jobGuids.0', undefined);
  });
  const data$ = from(request);
  return data$;
};
